export const SET_GROUPS = 'groups/set-groups';
export const REMOVE_GROUP = 'groups/remove-group';
export const SET_SELECTED_GROUP = 'groups/set-selected-group';
export const SET_REFERENCES = 'groups/set-references';
export const SET_GROUPS_TOTAL = 'groups/set-groups-total';
export const SET_GROUP_ENTRIES = 'groups/set-group-entries';
export const SET_MY_GROUPS = 'groups/set-my-groups';
